export default __webpack_public_path__ + "static/media/telegram.3f67818b.svg";